export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Учетные формы: Отчёт по фондам",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
